<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>{{ dialogTitle }}</h2>
    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <form [formGroup]="form">
      <label for="schedule-edit-title" sui-label>
        {{ "schedules-grid.label.title" | translate }}
      </label>
      <sui-input id="schedule-edit-title" formControlName="title"></sui-input>
    </form>

    <app-schedule-editor
      [parent]="form"
      mode="engine"
      [initialRecurrence]="schedule.recurrence_definition"
      [initialTimezoneId]="schedule.timezone_id"
    ></app-schedule-editor>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button variant="primary" (click)="save()">
      {{ "btn.save" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
